import { render, staticRenderFns } from "./Hyundai2023Ioniq6Disclosure.vue?vue&type=template&id=0c3675af&"
import script from "./Hyundai2023Ioniq6Disclosure.vue?vue&type=script&lang=js&"
export * from "./Hyundai2023Ioniq6Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports